import React, {useEffect, useRef, useState} from 'react'
import ApiRequest from 'EurestoApi/ApiRequest'
import project from 'EurestoConfig/project.config'
import Utils from "EurestoFonction/Utils";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input";
import User from "EurestoClass/User";
import EurestoTable from "Components/EurestoTable";
import Data from "EurestoClass/Data";
import Constants from "EurestoFonction/Constants";
import {InputAdornment} from "@material-ui/core";

const getDetailsFT = async (id) => {
    return await ApiRequest(project.api + 'gestion', {
        requete: 'produit',
        action: 'get',
        id: id,
    })
}
const getDetails = async (id) => {
    const r = await getDetailsFT(id)
    return r.results.details
}
export default React.memo(props => {

    const details = useRef([])
    const quantite = useRef(props.quantite)

    const etapes = useRef(props.details.filter(d => d.produit_id || d.etape === 1).reduce((a,b) =>
            b.etape === 1 && [...a, []] || [...a.slice(0, -1), [...(a.slice(-1)[0] || []), b.id || b.guid]]
        ,[]))
    const fts = useRef({})
    const datas = useRef([])

    const columns = useRef([])

    const cumuls = useRef({})

    const prixTotal = useRef(0)

    const [key, setKey] = useState(Utils.uuidv4(), [])
    const getInfo = async (ds) => {
        await Promise.all(ds.map(async (produit, i) => {
            if (produit.type_produit_id === 2 || produit.type_produit_id === 5) {
                const detailsFT = await getDetails(produit.produit_id)
                ds[i].details = await getInfo(detailsFT.filter(d => d.produit_id))
            }
        }))
        return ds;
    }

    useEffect(() => {
        const info = async () => {
            details.current = await getInfo(props.details.filter(d => d.produit_id))
            setKey(Utils.uuidv4())
        }
        info()
    }, [props.details])

    const onChangeQuantity = (q) => {
        quantite.current= q
        setKey(Utils.uuidv4())
    }

    const getDetail = (detail, quantiteNow, p, ft) => {
        const qt = Math.round(detail.quantite * quantiteNow*1000)/1000
        const prix = Math.round(qt*detail.prix*1000)/1000
        prixTotal.current += prix
        return ({
            [detail.produit_id]: {
                libelle: detail.produit_libelle,
                ...p,
                [ft]: {
                    quantite: detail.pour_memoire && 'PM' || qt,
                    prix: prix
                },
                unite_libelle: detail.libelle_part_unite || detail.libelle_unite,
                quantite: Math.round(((p.quantite || 0) + qt)*1000)/1000,
                prix_total: Math.round(((p.prix_total || 0) + prix)*1000)/1000,
                prix: detail.prix
            }
        })
    }

    console.log(etapes.current)

    const calcCumuls = (ds, quantiteNow, ft, libelle) => {
        (ds||[]).map(detail => {
            let etape = etapes.current.findIndex(e => e.indexOf(detail.id || detail.guid) !== -1)
            console.log(etape, detail)
            if(ft) {
                fts.current = {
                    ...fts.current || {},
                    [ft]: libelle
                }
            }
            if(!detail.details) {
                cumuls.current = {
                    ...(cumuls.current || {}),
                    [detail.famille_reference_id || detail.famille_id]: {
                        ...(cumuls.current && cumuls.current[detail.famille_reference_id || detail.famille_id] || {}),
                        ...(detail.famille_reference_id && {
                            ['s' + detail.famille_id]: {
                                ...(cumuls.current && cumuls.current[detail.famille_reference_id || detail.famille_id] && cumuls.current[detail.famille_reference_id || detail.famille_id]['s' + detail.famille_id] || {}),
                                ...getDetail(detail, quantiteNow, (cumuls.current && cumuls.current[detail.famille_reference_id || detail.famille_id]
                                    && cumuls.current[detail.famille_reference_id || detail.famille_id]['s' + detail.famille_id] &&
                                    cumuls.current[detail.famille_reference_id || detail.famille_id]['s' + detail.famille_id][detail.produit_id] || {}), ft || etape)
                            }
                        } || {
                            ...getDetail(detail, quantiteNow, (cumuls.current && cumuls.current[detail.famille_reference_id || detail.famille_id]
                                && cumuls.current[detail.famille_reference_id || detail.famille_id][detail.produit_id] || {}), ft || etape)
                        })
                    }
                }
            }
            if(detail.details) {
                calcCumuls(detail.details, detail.quantite*quantiteNow, detail.produit_id, detail.produit_libelle)
            }
        })
    }

    useEffect(() => {
        if(details.current && details.current.length > 0) {
            fts.current = {}
            cumuls.current = {}
            prixTotal.current = 0;
            calcCumuls(details.current || [], quantite.current/props.quantite)
            datas.current = Object.keys(cumuls.current || {}).map(key => {
                const famille = {
                    famille: true,
                    libelle: Data.get(Constants.module.GESTION, Constants.donnee.famille, {id: key}).libelle
                }
                famille.produits = Object.keys(cumuls.current[key]).filter(k => k[0] !== 's').map(k => cumuls.current[key][k]).sort((a, b) => a.libelle - b.libelle)
                famille.sfamille = Object.keys(cumuls.current[key]).filter(k => k[0] === 's').map(k => {
                    const skey = k.substring(1)
                    const sfamille = {
                        famille: true,
                        subfamille: true,
                        libelle: Data.get(Constants.module.GESTION, Constants.donnee.famille, {id: skey}).libelle
                    }
                    sfamille.produits = Object.keys(cumuls.current[key]['s'+skey]).filter(k => k[0] !== 's').map(k => cumuls.current[key]['s'+skey][k]).sort((a, b) => a.libelle - b.libelle)
                    return sfamille
                }).sort((a, b) => a.libelle - b.libelle)
                return famille
            }).sort((a, b) => a.libelle - b.libelle)
                .reduce((a, b) => [
                    ...a,
                    b,
                    ...b.produits || [],
                    ...(b.sfamille.sort((a1, b1) => a1.libelle - b1.libelle).reduce((a1, b1) => [...a1, b1, ...b1.produits], []))
                ], [])
            columns.current = [
                {
                    header: EurestoI18n.t('crm:Famille/Produit'),
                    headerClassName: 'EurestoPrimary EurestoText--text',
                    id: 'libelle',
                    type: 'string',
                    Cell: row => row.libelle
                }, {
                    header: <Grid container spacing={0} style={{padding: 0, margin: 0}} justify={"flex-end"}>{EurestoI18n.t('crm:Quantité Totale')}</Grid>,
                    id: 'quantite',
                    type: 'string',
                    Cell: row => <Grid container spacing={0} style={{padding: 0, margin: 0}} justify={"flex-end"}>{row.quantite}</Grid>
                }, {
                    header: <Grid container spacing={0} style={{padding: 0, margin: 0}} justify={"flex-end"}>{EurestoI18n.t('crm:Unité de Production')}</Grid>,
                    id: 'unite_libelle',
                    type: 'string',
                    Cell: row => <Grid container spacing={0} style={{padding: 0, margin: 0}} justify={"flex-end"}>{row.unite_libelle}</Grid>
                }, {
                    header: <Grid container spacing={0} style={{padding: 0, margin: 0}} justify={"flex-end"}>{EurestoI18n.t('crm:Prix PMP')}</Grid>,
                    id: 'prix',
                    type: 'string',
                    Cell: row => <Grid container spacing={0} style={{padding: 0, margin: 0}} justify={"flex-end"}>{row.prix}</Grid>
                }, {
                    header: <Grid container spacing={0} style={{padding: 0, margin: 0}} justify={"flex-end"}>{EurestoI18n.t('crm:Prix PMP Total')}</Grid>,
                    id: 'prix',
                    type: 'string',
                    Cell: row => <Grid container spacing={0} style={{padding: 0, margin: 0}} justify={"flex-end"}>{row.prix_total}</Grid>
                },
                ...((etapes.current||[]).map((_,e) => ({
                    header: <Grid container spacing={0} style={{padding: 0, margin: 0}} justify={"flex-end"}>{'Étape '+(e+1)}</Grid>,
                    id: 'quantite',
                    type: 'string',
                    Cell: row => <Grid container spacing={0} style={{padding: 0, margin: 0}} justify={"flex-end"}>{row[e] && row[e].quantite}</Grid>
                }))),
                ...(fts.current && Object.keys(fts.current||{}).length > 0 && Object.keys(fts.current).map(k => ({
                    header: <Grid container spacing={0} style={{padding: 0, margin: 0}} justify={"flex-end"}>{fts.current[k]}</Grid>,
                    id: 'quantite',
                    type: 'string',
                    Cell: row => <Grid container spacing={0} style={{padding: 0, margin: 0}} justify={"flex-end"}>{row[k] && row[k].quantite}</Grid>
                })) || [])
            ]
            setKey(Utils.uuidv4())
        }
    }, [details.current, quantite.current])


    return <React.Fragment>
        <Grid container spacing={0} direction={"column"} wrap={"nowrap"}
              style={Object.assign({
                  margin: 0,
                  padding: 10,
                  position: 'relative',
                  height: User.CalculHeight.getHeightWanted(92),
                  maxHeight: User.CalculHeight.getHeightWanted(92),
                  overflow: 'hidden',
              }, props.style || {})}
              justify={'flex-start'} alignContent={'flex-start'} alignItems={'flex-start'}>
            <EurestoTable
                styleRow={(row) => row.subfamille && {
                        backgroundColor: '#D3D3D3',
                    } || row.famille && {
                    backgroundColor: '#939393',
                    color: 'white'
                } || {}
                }
                key={columns.current}
                columns={columns.current}
                maxHeight={'100%'}
                style={{
                    maxHeight: '100%',
                }}
                datas={datas.current}/>
        </Grid>
        <Grid container direction={'row'} spacing={0} style={{padding: 0, margin: 0, height: 30, width: '100%'}}>
            <Grid item style={{padding: 0, margin: 0, width: 250}}>
                <Input inlineWidth={107} inline type={'number'} onChange={onChangeQuantity} title={EurestoI18n.t('gestion:Préparation Pour')} style={{marginBottom: 0}} value={quantite.current}
                   InputProps={{
                       endAdornment: <InputAdornment position="end">{props.nb_part_libelle}</InputAdornment>
                   }}/>
            </Grid>
            <Grid key={key} item style={{padding: 0, margin: 0, height: '100%'}}>
                <Grid container style={{ margin: 0, padding: 0, height: '100%' }} direction={'column'} justify={'center'}>
                    &nbsp;Pour un total de&nbsp;<b>{Math.round(prixTotal.current*1000)/1000}€</b>
                </Grid>
            </Grid>
        </Grid>
    </React.Fragment>
})


// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Component/Cumuls/index.js